import { CountryType } from "../interfaces";
export const countries: CountryType[] = [
  {
    value: "AD",
    latitude: 42.546245,
    longitude: 1.601554,
    label: "Andorra",
  },
  {
    value: "AE",
    latitude: 23.424076,
    longitude: 53.847818,
    label: "United Arab Emirates",
  },
  {
    value: "AF",
    latitude: 33.93911,
    longitude: 67.709953,
    label: "Afghanistan",
  },
  {
    value: "AG",
    latitude: 17.060816,
    longitude: -61.796428,
    label: "Antigua and Barbuda",
  },
  {
    value: "AI",
    latitude: 18.220554,
    longitude: -63.068615,
    label: "Anguilla",
  },
  {
    value: "AL",
    latitude: 41.153332,
    longitude: 20.168331,
    label: "Albania",
  },
  {
    value: "AM",
    latitude: 40.069099,
    longitude: 45.038189,
    label: "Armenia",
  },
  {
    value: "AO",
    latitude: -11.202692,
    longitude: 17.873887,
    label: "Angola",
  },
  {
    value: "AQ",
    latitude: -75.250973,
    longitude: -0.071389,
    label: "Antarctica",
  },
  {
    value: "AR",
    latitude: -38.416097,
    longitude: -63.616672,
    label: "Argentina",
  },
  {
    value: "AS",
    latitude: -14.270972,
    longitude: -170.132217,
    label: "American Samoa",
  },
  {
    value: "AT",
    latitude: 47.516231,
    longitude: 14.550072,
    label: "Austria",
  },
  {
    value: "AU",
    latitude: -25.274398,
    longitude: 133.775136,
    label: "Australia",
  },
  {
    value: "AW",
    latitude: 12.52111,
    longitude: -69.968338,
    label: "Aruba",
  },
  {
    value: "AZ",
    latitude: 40.143105,
    longitude: 47.576927,
    label: "Azerbaijan",
  },
  {
    value: "BA",
    latitude: 43.915886,
    longitude: 17.679076,
    label: "Bosnia and Herzegovina",
  },
  {
    value: "BB",
    latitude: 13.193887,
    longitude: -59.543198,
    label: "Barbados",
  },
  {
    value: "BD",
    latitude: 23.684994,
    longitude: 90.356331,
    label: "Bangladesh",
  },
  {
    value: "BE",
    latitude: 50.503887,
    longitude: 4.469936,
    label: "Belgium",
  },
  {
    value: "BF",
    latitude: 12.238333,
    longitude: -1.561593,
    label: "Burkina Faso",
  },
  {
    value: "BG",
    latitude: 42.733883,
    longitude: 25.48583,
    label: "Bulgaria",
  },
  {
    value: "BH",
    latitude: 25.930414,
    longitude: 50.637772,
    label: "Bahrain",
  },
  {
    value: "BI",
    latitude: -3.373056,
    longitude: 29.918886,
    label: "Burundi",
  },
  {
    value: "BJ",
    latitude: 9.30769,
    longitude: 2.315834,
    label: "Benin",
  },
  {
    value: "BM",
    latitude: 32.321384,
    longitude: -64.75737,
    label: "Bermuda",
  },
  {
    value: "BN",
    latitude: 4.535277,
    longitude: 114.727669,
    label: "Brunei",
  },
  {
    value: "BO",
    latitude: -16.290154,
    longitude: -63.588653,
    label: "Bolivia",
  },
  {
    value: "BR",
    latitude: -14.235004,
    longitude: -51.92528,
    label: "Brazil",
  },
  {
    value: "BS",
    latitude: 25.03428,
    longitude: -77.39628,
    label: "Bahamas",
  },
  {
    value: "BT",
    latitude: 27.514162,
    longitude: 90.433601,
    label: "Bhutan",
  },
  {
    value: "BV",
    latitude: -54.423199,
    longitude: 3.413194,
    label: "Bouvet Island",
  },
  {
    value: "BW",
    latitude: -22.328474,
    longitude: 24.684866,
    label: "Botswana",
  },
  {
    value: "BY",
    latitude: 53.709807,
    longitude: 27.953389,
    label: "Belarus",
  },
  {
    value: "BZ",
    latitude: 17.189877,
    longitude: -88.49765,
    label: "Belize",
  },
  {
    value: "CA",
    latitude: 56.130366,
    longitude: -106.346771,
    label: "Canada",
  },
  {
    value: "CC",
    latitude: -12.164165,
    longitude: 96.870956,
    label: "Cocos Islands",
  },
  {
    value: "CD",
    latitude: -4.038333,
    longitude: 21.758664,
    label: "Democratic Republic of the Congo",
  },
  {
    value: "CF",
    latitude: 6.611111,
    longitude: 20.939444,
    label: "Central African Republic",
  },
  {
    value: "CG",
    latitude: -0.228021,
    longitude: 15.827659,
    label: "Congo",
  },
  {
    value: "CH",
    latitude: 46.818188,
    longitude: 8.227512,
    label: "Switzerland",
  },
  {
    value: "CI",
    latitude: 7.539989,
    longitude: -5.54708,
    label: "Côte d'Ivoire",
  },
  {
    value: "CK",
    latitude: -21.236736,
    longitude: -159.777671,
    label: "Cook Islands",
  },
  {
    value: "CL",
    latitude: -35.675147,
    longitude: -71.542969,
    label: "Chile",
  },
  {
    value: "CM",
    latitude: 7.369722,
    longitude: 12.354722,
    label: "Cameroon",
  },
  {
    value: "CN",
    latitude: 35.86166,
    longitude: 104.195397,
    label: "China",
  },
  {
    value: "CO",
    latitude: 4.570868,
    longitude: -74.297333,
    label: "Colombia",
  },
  {
    value: "CR",
    latitude: 9.748917,
    longitude: -83.753428,
    label: "Costa Rica",
  },
  {
    value: "CU",
    latitude: 21.521757,
    longitude: -77.781167,
    label: "Cuba",
  },
  {
    value: "CV",
    latitude: 16.002082,
    longitude: -24.013197,
    label: "Cape Verde",
  },
  {
    value: "CX",
    latitude: -10.447525,
    longitude: 105.690449,
    label: "Christmas Island",
  },
  {
    value: "CY",
    latitude: 35.126413,
    longitude: 33.429859,
    label: "Cyprus",
  },
  {
    value: "CZ",
    latitude: 49.817492,
    longitude: 15.472962,
    label: "Czechia",
  },
  {
    value: "DE",
    latitude: 51.165691,
    longitude: 10.451526,
    label: "Germany",
  },
  {
    value: "DJ",
    latitude: 11.825138,
    longitude: 42.590275,
    label: "Djibouti",
  },
  {
    value: "DK",
    latitude: 56.26392,
    longitude: 9.501785,
    label: "Denmark",
  },
  {
    value: "DM",
    latitude: 15.414999,
    longitude: -61.370976,
    label: "Dominica",
  },
  {
    value: "DO",
    latitude: 18.735693,
    longitude: -70.162651,
    label: "Dominican Republic",
  },
  {
    value: "DZ",
    latitude: 28.033886,
    longitude: 1.659626,
    label: "Algeria",
  },
  {
    value: "EC",
    latitude: -1.831239,
    longitude: -78.183406,
    label: "Ecuador",
  },
  {
    value: "EE",
    latitude: 58.595272,
    longitude: 25.013607,
    label: "Estonia",
  },
  {
    value: "EG",
    latitude: 26.820553,
    longitude: 30.802498,
    label: "Egypt",
  },
  {
    value: "EH",
    latitude: 24.215527,
    longitude: -12.885834,
    label: "Western Sahara",
  },
  {
    value: "ER",
    latitude: 15.179384,
    longitude: 39.782334,
    label: "Eritrea",
  },
  {
    value: "ES",
    latitude: 40.463667,
    longitude: -3.74922,
    label: "Spain",
  },
  {
    value: "ET",
    latitude: 9.145,
    longitude: 40.489673,
    label: "Ethiopia",
  },
  {
    value: "FI",
    latitude: 61.92411,
    longitude: 25.748151,
    label: "Finland",
  },
  {
    value: "FJ",
    latitude: -16.578193,
    longitude: 179.414413,
    label: "Fiji",
  },
  {
    value: "FK",
    latitude: -51.796253,
    longitude: -59.523613,
    label: "Falkland Islands (Malvinas)",
  },
  {
    value: "FO",
    latitude: 61.892635,
    longitude: -6.911806,
    label: "Faroe Islands",
  },
  {
    value: "FR",
    latitude: 46.227638,
    longitude: 2.213749,
    label: "France",
  },
  {
    value: "GA",
    latitude: -0.803689,
    longitude: 11.609444,
    label: "Gabon",
  },
  {
    value: "GB",
    latitude: 55.378051,
    longitude: -3.435973,
    label: "United Kingdom",
  },
  {
    value: "GD",
    latitude: 12.262776,
    longitude: -61.604171,
    label: "Grenada",
  },
  {
    value: "GE",
    latitude: 42.315407,
    longitude: 43.356892,
    label: "Georgia",
  },
  {
    value: "GF",
    latitude: 3.933889,
    longitude: -53.125782,
    label: "French Guiana",
  },
  {
    value: "GG",
    latitude: 49.465691,
    longitude: -2.585278,
    label: "Guernsey",
  },
  {
    value: "GH",
    latitude: 7.946527,
    longitude: -1.023194,
    label: "Ghana",
  },
  {
    value: "GI",
    latitude: 36.137741,
    longitude: -5.345374,
    label: "Gibraltar",
  },
  {
    value: "GL",
    latitude: 71.706936,
    longitude: -42.604303,
    label: "Greenland",
  },
  {
    value: "GM",
    latitude: 13.443182,
    longitude: -15.310139,
    label: "Gambia",
  },
  {
    value: "GN",
    latitude: 9.945587,
    longitude: -9.696645,
    label: "Guinea",
  },
  {
    value: "GP",
    latitude: 16.08663,
    longitude: -61.422873,
    label: "Guadeloupe",
  },
  {
    value: "GQ",
    latitude: 1.650801,
    longitude: 10.267895,
    label: "Equatorial Guinea",
  },
  {
    value: "GR",
    latitude: 39.074208,
    longitude: 21.824312,
    label: "Greece",
  },
  {
    value: "GS",
    latitude: -54.429579,
    longitude: -36.587909,
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    value: "GT",
    latitude: 15.783471,
    longitude: -90.230759,
    label: "Guatemala",
  },
  {
    value: "GU",
    latitude: 13.444304,
    longitude: 144.793731,
    label: "Guam",
  },
  {
    value: "GW",
    latitude: 11.803749,
    longitude: -15.180413,
    label: "Guinea-Bissau",
  },
  {
    value: "GY",
    latitude: 4.860416,
    longitude: -58.93018,
    label: "Guyana",
  },
  {
    value: "HK",
    latitude: 22.396428,
    longitude: 114.109497,
    label: "Hong Kong",
  },
  {
    value: "HM",
    latitude: -53.08181,
    longitude: 73.504158,
    label: "Heard Island and McDonald Islands",
  },
  {
    value: "HN",
    latitude: 15.199999,
    longitude: -86.241905,
    label: "Honduras",
  },
  {
    value: "HR",
    latitude: 45.1,
    longitude: 15.2,
    label: "Croatia",
  },
  {
    value: "HT",
    latitude: 18.971187,
    longitude: -72.285215,
    label: "Haiti",
  },
  {
    value: "HU",
    latitude: 47.162494,
    longitude: 19.503304,
    label: "Hungary",
  },
  {
    value: "ID",
    latitude: -0.789275,
    longitude: 113.921327,
    label: "Indonesia",
  },
  {
    value: "IE",
    latitude: 53.41291,
    longitude: -8.24389,
    label: "Ireland",
  },
  {
    value: "IL",
    latitude: 31.046051,
    longitude: 34.851612,
    label: "Israel",
  },
  {
    value: "IM",
    latitude: 54.236107,
    longitude: -4.548056,
    label: "Isle of Man",
  },
  {
    value: "IN",
    latitude: 20.593684,
    longitude: 78.96288,
    label: "India",
  },
  {
    value: "IO",
    latitude: -6.343194,
    longitude: 71.876519,
    label: "British Indian Ocean Territory (Diego Garcia)",
  },
  {
    value: "IQ",
    latitude: 33.223191,
    longitude: 43.679291,
    label: "Iraq",
  },
  {
    value: "IR",
    latitude: 32.427908,
    longitude: 53.688046,
    label: "Iran",
  },
  {
    value: "IS",
    latitude: 64.963051,
    longitude: -19.020835,
    label: "Iceland",
  },
  {
    value: "IT",
    latitude: 41.87194,
    longitude: 12.56738,
    label: "Italy",
  },
  {
    value: "JM",
    latitude: 18.109581,
    longitude: -77.297508,
    label: "Jamaica",
  },
  {
    value: "JO",
    latitude: 30.585164,
    longitude: 36.238414,
    label: "Jordan",
  },
  {
    value: "JP",
    latitude: 36.204824,
    longitude: 138.252924,
    label: "Japan",
  },
  {
    value: "KE",
    latitude: -0.023559,
    longitude: 37.906193,
    label: "Kenya",
  },
  {
    value: "KG",
    latitude: 41.20438,
    longitude: 74.766098,
    label: "Kyrgyzstan",
  },
  {
    value: "KH",
    latitude: 12.565679,
    longitude: 104.990963,
    label: "Cambodia",
  },
  {
    value: "KI",
    latitude: -3.370417,
    longitude: -168.734039,
    label: "Kiribati",
  },
  {
    value: "KM",
    latitude: -11.875001,
    longitude: 43.872219,
    label: "Comoros",
  },
  {
    value: "KN",
    latitude: 17.357822,
    longitude: -62.782998,
    label: "Saint Kitts and Nevis",
  },
  {
    value: "KP",
    latitude: 40.339852,
    longitude: 127.510093,
    label: "North Korea",
  },
  {
    value: "KR",
    latitude: 35.907757,
    longitude: 127.766922,
    label: "South Korea",
  },
  {
    value: "KW",
    latitude: 29.31166,
    longitude: 47.481766,
    label: "Kuwait",
  },
  {
    value: "KY",
    latitude: 19.513469,
    longitude: -80.566956,
    label: "Cayman Islands",
  },
  {
    value: "KZ",
    latitude: 48.019573,
    longitude: 66.923684,
    label: "Kazakhstan",
  },
  {
    value: "LA",
    latitude: 19.85627,
    longitude: 102.495496,
    label: "Laos",
  },
  {
    value: "LB",
    latitude: 33.854721,
    longitude: 35.862285,
    label: "Lebanon",
  },
  {
    value: "LC",
    latitude: 13.909444,
    longitude: -60.978893,
    label: "Saint Lucia",
  },
  {
    value: "LI",
    latitude: 47.166,
    longitude: 9.555373,
    label: "Liechtenstein",
  },
  {
    value: "LK",
    latitude: 7.873054,
    longitude: 80.771797,
    label: "Sri Lanka",
  },
  {
    value: "LR",
    latitude: 6.428055,
    longitude: -9.429499,
    label: "Liberia",
  },
  {
    value: "LS",
    latitude: -29.609988,
    longitude: 28.233608,
    label: "Lesotho",
  },
  {
    value: "LT",
    latitude: 55.169438,
    longitude: 23.881275,
    label: "Lithuania",
  },
  {
    value: "LU",
    latitude: 49.815273,
    longitude: 6.129583,
    label: "Luxembourg",
  },
  {
    value: "LV",
    latitude: 56.879635,
    longitude: 24.603189,
    label: "Latvia",
  },
  {
    value: "LY",
    latitude: 26.3351,
    longitude: 17.228331,
    label: "Libya",
  },
  {
    value: "MA",
    latitude: 31.791702,
    longitude: -7.09262,
    label: "Morocco",
  },
  {
    value: "MC",
    latitude: 43.750298,
    longitude: 7.412841,
    label: "Monaco",
  },
  {
    value: "MD",
    latitude: 47.411631,
    longitude: 28.369885,
    label: "Moldova",
  },
  {
    value: "ME",
    latitude: 42.708678,
    longitude: 19.37439,
    label: "Montenegro",
  },
  {
    value: "MG",
    latitude: -18.766947,
    longitude: 46.869107,
    label: "Madagascar",
  },
  {
    value: "MK",
    latitude: 41.608635,
    longitude: 21.745275,
    label: "North Macedonia",
  },
  {
    value: "ML",
    latitude: 17.570692,
    longitude: -3.996166,
    label: "Mali",
  },
  {
    value: "MM",
    latitude: 21.913965,
    longitude: 95.956223,
    label: "Myanmar",
  },
  {
    value: "MN",
    latitude: 46.862496,
    longitude: 103.846656,
    label: "Mongolia",
  },
  {
    value: "MO",
    latitude: 22.198745,
    longitude: 113.543873,
    label: "Macau",
  },
  {
    value: "MQ",
    latitude: 14.641528,
    longitude: -61.024174,
    label: "Martinique",
  },
  {
    value: "MR",
    latitude: 21.00789,
    longitude: -10.940835,
    label: "Mauritania",
  },
  {
    value: "MS",
    latitude: 16.742498,
    longitude: -62.187366,
    label: "Montserrat",
  },
  {
    value: "MT",
    latitude: 35.937496,
    longitude: 14.375416,
    label: "Malta",
  },
  {
    value: "MU",
    latitude: -20.348404,
    longitude: 57.552152,
    label: "Mauritius",
  },
  {
    value: "MV",
    latitude: 3.202778,
    longitude: 73.22068,
    label: "Maldives",
  },
  {
    value: "MW",
    latitude: -13.254308,
    longitude: 34.301525,
    label: "Malawi",
  },
  {
    value: "MX",
    latitude: 23.634501,
    longitude: -102.552784,
    label: "Mexico",
  },
  {
    value: "MY",
    latitude: 4.040255,
    longitude: 109.091912,
    label: "Malaysia",
  },
  {
    value: "MZ",
    latitude: -18.665695,
    longitude: 35.529562,
    label: "Mozambique",
  },
  {
    value: "NA",
    latitude: -22.95764,
    longitude: 18.49041,
    label: "Namibia",
  },
  {
    value: "NC",
    latitude: -20.904305,
    longitude: 165.618042,
    label: "New Caledonia",
  },
  {
    value: "NE",
    latitude: 17.607789,
    longitude: 8.081666,
    label: "Niger",
  },
  {
    value: "NF",
    latitude: -29.040835,
    longitude: 167.954712,
    label: "Norfolk Island",
  },
  {
    value: "NG",
    latitude: 9.081999,
    longitude: 8.675277,
    label: "Nigeria",
  },
  {
    value: "NI",
    latitude: 12.865416,
    longitude: -85.207229,
    label: "Nicaragua",
  },
  {
    value: "NL",
    latitude: 52.132633,
    longitude: 5.291266,
    label: "Netherlands",
  },
  {
    value: "NO",
    latitude: 60.472024,
    longitude: 8.468946,
    label: "Norway",
  },
  {
    value: "NP",
    latitude: 28.394857,
    longitude: 84.124008,
    label: "Nepal",
  },
  {
    value: "NR",
    latitude: -0.522778,
    longitude: 166.931503,
    label: "Nauru",
  },
  {
    value: "NU",
    latitude: -19.054445,
    longitude: -169.867233,
    label: "Niue",
  },
  {
    value: "NZ",
    latitude: -40.900557,
    longitude: 174.885971,
    label: "New Zealand",
  },
  {
    value: "OM",
    latitude: 21.512583,
    longitude: 55.923255,
    label: "Oman",
  },
  {
    value: "PA",
    latitude: 8.537981,
    longitude: -80.782127,
    label: "Panama",
  },
  {
    value: "PE",
    latitude: -9.189967,
    longitude: -75.015152,
    label: "Peru",
  },
  {
    value: "PF",
    latitude: -17.679742,
    longitude: -149.406843,
    label: "French Polynesia",
  },
  {
    value: "PG",
    latitude: -6.314993,
    longitude: 143.95555,
    label: "Papua New Guinea",
  },
  {
    value: "PH",
    latitude: 12.879721,
    longitude: 121.774017,
    label: "Philippines",
  },
  {
    value: "PK",
    latitude: 30.375321,
    longitude: 69.345116,
    label: "Pakistan",
  },
  {
    value: "PL",
    latitude: 51.919438,
    longitude: 19.145136,
    label: "Poland",
  },
  {
    value: "PM",
    latitude: 46.941936,
    longitude: -56.27111,
    label: "Saint Pierre and Miquelon",
  },
  {
    value: "PN",
    latitude: -24.703615,
    longitude: -127.439308,
    label: "Pitcairn Islands",
  },
  {
    value: "PR",
    latitude: 18.220833,
    longitude: -66.590149,
    label: "Puerto Rico",
  },
  {
    value: "PT",
    latitude: 39.399872,
    longitude: -8.224454,
    label: "Portugal",
  },
  {
    value: "PW",
    latitude: 7.51498,
    longitude: 134.58252,
    label: "Palau",
  },
  {
    value: "PY",
    latitude: -23.442503,
    longitude: -58.443832,
    label: "Paraguay",
  },
  {
    value: "QA",
    latitude: 25.354826,
    longitude: 51.183884,
    label: "Qatar",
  },
  {
    value: "RE",
    latitude: -21.115141,
    longitude: 55.536384,
    label: "Réunion",
  },
  {
    value: "RO",
    latitude: 45.943161,
    longitude: 24.96676,
    label: "Romania",
  },
  {
    value: "RS",
    latitude: 44.016521,
    longitude: 21.005859,
    label: "Serbia",
  },
  {
    value: "RU",
    latitude: 61.52401,
    longitude: 105.318756,
    label: "Russia",
  },
  {
    value: "RW",
    latitude: -1.940278,
    longitude: 29.873888,
    label: "Rwanda",
  },
  {
    value: "SA",
    latitude: 23.885942,
    longitude: 45.079162,
    label: "Saudi Arabia",
  },
  {
    value: "SB",
    latitude: -9.64571,
    longitude: 160.156194,
    label: "Solomon Islands",
  },
  {
    value: "SC",
    latitude: -4.679574,
    longitude: 55.491977,
    label: "Seychelles",
  },
  {
    value: "SD",
    latitude: 15.8905231,
    longitude: 30.7671933,
    label: "Sudan",
  },
  {
    value: "SS",
    latitude: 6.85065,
    longitude: 30.659016,
    label: "South Sudan",
  },
  {
    value: "SE",
    latitude: 60.128161,
    longitude: 18.643501,
    label: "Sweden",
  },
  {
    value: "SG",
    latitude: 1.352083,
    longitude: 103.819836,
    label: "Singapore",
  },
  {
    value: "SH",
    latitude: -24.143474,
    longitude: -10.030696,
    label: "Saint Helena",
  },
  {
    value: "SI",
    latitude: 46.151241,
    longitude: 14.995463,
    label: "Slovenia",
  },
  {
    value: "SJ",
    latitude: 77.553604,
    longitude: 23.670272,
    label: "Svalbard and Jan Mayen",
  },
  {
    value: "SK",
    latitude: 48.669026,
    longitude: 19.699024,
    label: "Slovakia",
  },
  {
    value: "SL",
    latitude: 8.460555,
    longitude: -11.779889,
    label: "Sierra Leone",
  },
  {
    value: "SM",
    latitude: 43.94236,
    longitude: 12.457777,
    label: "San Marino",
  },
  {
    value: "SN",
    latitude: 14.497401,
    longitude: -14.452362,
    label: "Senegal",
  },
  {
    value: "SO",
    latitude: 5.152149,
    longitude: 46.199616,
    label: "Somalia",
  },
  {
    value: "SR",
    latitude: 3.919305,
    longitude: -56.027783,
    label: "Suriname",
  },
  {
    value: "ST",
    latitude: 0.18636,
    longitude: 6.613081,
    label: "São Tomé and Príncipe",
  },
  {
    value: "SV",
    latitude: 13.794185,
    longitude: -88.89653,
    label: "El Salvador",
  },
  {
    value: "SY",
    latitude: 34.802075,
    longitude: 38.996815,
    label: "Syria",
  },
  {
    value: "SZ",
    latitude: -26.522503,
    longitude: 31.465866,
    label: "Eswatini",
  },
  {
    value: "TC",
    latitude: 21.694025,
    longitude: -71.797928,
    label: "Turks and Caicos Islands",
  },
  {
    value: "TD",
    latitude: 15.454166,
    longitude: 18.732207,
    label: "Chad",
  },
  {
    value: "TF",
    latitude: -49.280366,
    longitude: 69.348557,
    label: "French Southern Territories - Kerguelen Islands",
  },
  {
    value: "TG",
    latitude: 8.619543,
    longitude: 0.824782,
    label: "Togo",
  },
  {
    value: "TH",
    latitude: 15.870032,
    longitude: 100.992541,
    label: "Thailand",
  },
  {
    value: "TJ",
    latitude: 38.861034,
    longitude: 71.276093,
    label: "Tajikistan",
  },
  {
    value: "TK",
    latitude: -8.967363,
    longitude: -171.855881,
    label: "Tokelau",
  },
  {
    value: "TL",
    latitude: -8.874217,
    longitude: 125.727539,
    label: "Timor-Leste",
  },
  {
    value: "TM",
    latitude: 38.969719,
    longitude: 59.556278,
    label: "Turkmenistan",
  },
  {
    value: "TN",
    latitude: 33.886917,
    longitude: 9.537499,
    label: "Tunisia",
  },
  {
    value: "TO",
    latitude: -21.178986,
    longitude: -175.198242,
    label: "Tonga",
  },
  {
    value: "TR",
    latitude: 38.963745,
    longitude: 35.243322,
    label: "Turkey",
  },
  {
    value: "TT",
    latitude: 10.691803,
    longitude: -61.222503,
    label: "Trinidad and Tobago",
  },
  {
    value: "TW",
    latitude: 23.69781,
    longitude: 120.960515,
    label: "Taiwan",
  },
  {
    value: "TZ",
    latitude: -6.369028,
    longitude: 34.888822,
    label: "Tanzania",
  },
  {
    value: "UA",
    latitude: 48.379433,
    longitude: 31.16558,
    label: "Ukraine",
  },
  {
    value: "UG",
    latitude: 1.373333,
    longitude: 32.290275,
    label: "Uganda",
  },
  {
    value: "US",
    latitude: 37.09024,
    longitude: -95.712891,
    label: "United States",
  },
  {
    value: "UY",
    latitude: -32.522779,
    longitude: -55.765835,
    label: "Uruguay",
  },
  {
    value: "UZ",
    latitude: 41.377491,
    longitude: 64.585262,
    label: "Uzbekistan",
  },
  {
    value: "VA",
    latitude: 41.902916,
    longitude: 12.453389,
    label: "Vatican City",
  },
  {
    value: "VC",
    latitude: 12.984305,
    longitude: -61.287228,
    label: "Saint Vincent and the Grenadines",
  },
  {
    value: "VE",
    latitude: 6.42375,
    longitude: -66.58973,
    label: "Venezuela",
  },
  {
    value: "VG",
    latitude: 18.420695,
    longitude: -64.639968,
    label: "British Virgin Islands",
  },
  {
    value: "VI",
    latitude: 18.335765,
    longitude: -64.896335,
    label: "U.S. Virgin Islands",
  },
  {
    value: "VN",
    latitude: 14.058324,
    longitude: 108.277199,
    label: "Vietnam",
  },
  {
    value: "VU",
    latitude: -15.376706,
    longitude: 166.959158,
    label: "Vanuatu",
  },
  {
    value: "WF",
    latitude: -13.768752,
    longitude: -177.156097,
    label: "Wallis and Futuna",
  },
  {
    value: "WS",
    latitude: -13.759029,
    longitude: -172.104629,
    label: "Samoa",
  },
  {
    value: "YE",
    latitude: 15.552727,
    longitude: 48.516388,
    label: "Yemen",
  },
  {
    value: "YT",
    latitude: -12.8275,
    longitude: 45.166244,
    label: "Mayotte",
  },
  {
    value: "ZA",
    latitude: -30.559482,
    longitude: 22.937506,
    label: "South Africa",
  },
  {
    value: "ZM",
    latitude: -13.133897,
    longitude: 27.849332,
    label: "Zambia",
  },
  {
    value: "ZW",
    latitude: -19.015438,
    longitude: 29.154857,
    label: "Zimbabwe",
  },
];
